// src/utils/jwt.js

import axios from "axios";
import jwtDecode from "jwt-decode";

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decodedToken = jwtDecode(accessToken);
  const currentTime = Date.now() / 1000;

  return decodedToken.exp > currentTime;
};

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // Also set as cookie for subdomain access (e.g., code.datajolt.io)
    // Decode JWT to get expiration time
    const decodedToken = jwtDecode(accessToken);
    const expiryDate = new Date(decodedToken.exp * 1000);

    document.cookie = `accessToken=${accessToken}; path=/; domain=.datajolt.io; expires=${expiryDate.toUTCString()}; secure; samesite=none`;
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;

    // Clear cookie
    document.cookie = 'accessToken=; path=/; domain=.datajolt.io; expires=Thu, 01 Jan 1970 00:00:00 UTC; secure; samesite=none';
  }
};

export { isValidToken, setSession };
